import DataTable from '@/containers/data_table_ml/DataTable';
import {
  versionStatus,
  approvalStatusWithoutApproval,
  currentOperation,
} from '@/constants.js';
import Action from '../action/Action';
const TablePage = (props) => {
  const { loadingstatus, tableData } = props || {};
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 50,
      align: 'center',
    },
    {
      title: '决策图名称',
      dataIndex: 'name',
      key: 'name',
      width: 190,
    },
    {
      title: '版本号',
      dataIndex: 'version',
      key: 'version',
      width: 90,
    },
    {
      title: '提交人',
      dataIndex: 'submitStaff',
      key: 'submitStaff',
      width: 100,
    },
    {
      title: '审批人',
      dataIndex: 'approvalStaff',
      key: 'approvalStaff',
      width: 100,
    },
    {
      title: '更新时间',
      dataIndex: 'updateTime',
      key: 'updateTime',
      width: 100,
      align: 'center',
    },
    {
      title: '上线时间',
      dataIndex: 'onlineTime',
      key: 'onlineTime',
      width: 100,
      align: 'center',
    },
    {
      title: '下线时间',
      dataIndex: 'offlineTime',
      key: 'offlineTime',
      width: 100,
      align: 'center',
    },
    {
      title: '当前操作',
      dataIndex: 'currentOperation',
      key: 'currentOperation',
      width: 80,
      align: 'center',
      render: (text) => {
        return currentOperation[text];
      },
    },
    {
      title: '审批状态',
      dataIndex: 'approvalStatus',
      key: 'approvalStatus',
      width: 60,
      align: 'center',
      render: (text) => {
        return approvalStatusWithoutApproval[text];
      },
    },
    {
      title: '版本状态',
      dataIndex: 'versionStatus',
      key: 'versionStatus',
      width: 60,
      align: 'center',
      render: (text) => {
        return versionStatus[text];
      },
    },
    {
      title: '操作',
      render: (record) => {
        if (record.approvalStatus === 'PENDING_APPROVAL') {
          return <Action id={record.id} />;
        }
        return '';
      },
      width: 190,
    },
  ];
  return (
    <DataTable
      className="demo-test"
      // style={{ minWidth: '1547px' }}
      columns={columns}
      rowSelection={false}
      // pagination={pagination}
      scroll={{
        x: 1547,
        y: 'calc(100vh - 64px - 46px - 47px - 60px - 2rem)',
      }}
      loading={loadingstatus}
      dataSource={tableData}
      // changePage={(a) => {
      //   props.pageNumChange(a);
      // }}
      // changePageSize={(a) => {
      //   props.pageSizeChange(a);
      // }}
    />
  );
};
export default TablePage;
